import { RECORD_RESULT } from '@/components/orders/feasibilityText'

/** SA-1016 / SA-1419: an attention task whose step still waits (a timer's task on an event wait) says
 * where the event that ends the step is issued, above its own form and exits. Worded by the awaited event
 * first (`TaskRead.waiting_for_event`), then by the wait's surface (an older server names no event). */
export interface AttentionLine {
  line: string
  link: string
  panel: string
}

const QUOTES_LINK = 'Open the quote versions'

const BY_EVENT: Record<string, AttentionLine> = {
  quote_response_recorded: {
    line: 'A late response from the customer is recorded on the record’s quote versions, and moves the process on.',
    link: QUOTES_LINK,
    panel: 'quotes',
  },
  quote_version_sent: {
    line: 'A quote sent to the customer, emailed from the Inbox or marked sent on the record’s quote versions, moves the process on.',
    link: QUOTES_LINK,
    panel: 'quotes',
  },
  feasibility_recorded: {
    line: 'A feasibility result recorded on the record moves the process on.',
    link: RECORD_RESULT,
    panel: 'feasibility',
  },
}

// One entry per wait surface (the closed WAIT_SURFACES).
const BY_SURFACE: Record<string, AttentionLine> = {
  'record.quotes': BY_EVENT.quote_response_recorded,
  'record.feasibility': BY_EVENT.feasibility_recorded,
}

export function attentionLine(event: string | null | undefined, surface: string): AttentionLine | null {
  return (event ? BY_EVENT[event] : undefined) ?? BY_SURFACE[surface] ?? null
}
